import apiClient from "./index";
import { showToast } from "../pages/common/components/Toast";


export const addProduct = async ({ name, price, stock, category, image_url, store_id, unlimited_stock }) => {
  console.log("🛠 상품 추가 요청 시작:", { name, price, stock, category, image_url, store_id, unlimited_stock });
  try {
    const response = await apiClient.post("/products", {
      name,
      price,
      stock,
      category,
      image_url,
      store_id,
      unlimited_stock
    });

    console.log("✅ 상품 추가 API 전체 응답:", response);
console.log("✅ response.data:", response.data);

    return response.data;
  } catch (error) {
    // 삼키면 "등록되지 않은 카테고리입니다" 같은 서버 사유가 화면에 닿지 못한다
    console.error("❌ 상품 추가 실패:", error.response?.data || error.message);
    throw error;
  }
};

// 전체 카테고리 목록 불러오기
export const getCategories = async () => {
  try {
    const response = await apiClient.get("/products/categories");
    return response.data;
  } catch (error) {
    // console.error("❌ 카테고리 목록 불러오기 오류:", error.message);
    return [];
  }
};

// 카테고리 추가 (관리자)
// 중복·길이 위반은 400과 함께 사유 문구가 오므로, 호출부가 그대로 보여줄 수 있게 삼키지 않고 던진다.
export const addCategory = async (name, imageUrl) => {
  const response = await apiClient.post("/products/categories", {
    name,
    image_url: imageUrl || null,
  });
  return response.data;
};

// 카테고리 삭제 (관리자)
// 상품이 남아 있으면 400과 함께 안내 문구가 오므로, 마찬가지로 던져서 호출부가 전달하게 한다.
export const deleteCategory = async (name) => {
  const response = await apiClient.delete(`/products/categories/${encodeURIComponent(name)}`);
  return response.data;
};

// 표시 순서를 이웃과 맞바꾼다 (direction: "up" | "down")
export const moveCategory = async (name, direction) => {
  const response = await apiClient.patch(
    `/products/categories/${encodeURIComponent(name)}/order`, { direction }
  );
  return response.data;
};

export const changeCategoryImage = async (name, imageUrl) => {
  const response = await apiClient.patch(
    `/products/categories/${encodeURIComponent(name)}/image`, { image_url: imageUrl }
  );
  return response.data;
};

// 특정 카테고리 상품 가져오기 (고객 페이지 전용 API)
export const getProductsByCategory = async (category) => {
  try {
    // console.log(`🛠 [${category}] 카테고리 상품 가져오기 시작`);

    const response = await apiClient.get(`/products/category/${encodeURIComponent(category)}`);
    // console.log(`🛠 [${category}] 가져온 상품 데이터:`, response.data);
    
    return response.data;
  } catch (error) {
    // console.error(`❌ [${category}] 카테고리 상품 불러오기 오류:`, error.message);
    return [];
  }
};


// 상품 목록 불러오기
export const getProducts = async () => {
  try {
    const response = await apiClient.get("/products");

    // 🔥 API 응답 데이터에서 `image_url`을 `imageUrl`로 매핑
    const formattedData = response.data.map((product) => ({
      ...product,
      imageUrl: product.image_url, // ✅ `image_url`을 `imageUrl`로 변환
    }));

    return formattedData;
  } catch (error) {
    // console.error("❌ 상품 목록 가져오기 실패:", error);
    return [];
  }
};
// export const getProducts = async (storeId) => {
//   try {
//     const response = await apiClient.get(`/products?store_id=${storeId}`);
//     return response.data;
//   } catch (error) {
//     console.error("❌ 상품 조회 실패:", error);
//     return [];
//   }
// };

// 상품 정보 수정 (자동 저장)
export const updateProduct = async (productId, updateData) => {
  try {
    if (!updateData.name || !updateData.price || !updateData.category) {
      console.error("❌ updateProduct 오류: 필수 값 누락", updateData);
      return;
    }

    // 🔥 백엔드 스키마에 맞게 `imageUrl`을 `image_url`로 변경
    const formattedData = {
      name: updateData.name,
      price: parseInt(updateData.price, 10) || 0,  // 🔹 숫자 변환
      stock: parseInt(updateData.stock, 10) || 0,  // 🔹 숫자 변환
      category: updateData.category,
      // 이미지가 없으면 서버가 Storage의 기본 이미지 주소를 채운다.
      // 여기서 로컬 경로(/images/DEFAULT.png)를 보내면 그 문자열이 DB에 그대로 저장된다.
      image_url: updateData.image_url || null,
      store_id: updateData.store_id,
      unlimited_stock: updateData.unlimited_stock,
    };
    // delete formattedData.imageUrl; // ✅ 불필요한 필드 삭제

    // console.log("🛠 업데이트 요청 데이터 (수정됨):", formattedData); // 확인용

    const response = await apiClient.put(`/products/${productId}`, formattedData);
    return response.data;
  } catch (error) {
    // 조용히 삼키면 화면에는 수정된 값이 보이는데 DB는 그대로인 상태가 된다
    console.error("❌ 상품 수정 실패:", error.response?.data?.error || error.message);
    showToast(error.response?.data?.error || "상품 수정에 실패했습니다.", "fail");
    throw error;
  }
};

// 상품 삭제 함수
export const deleteProducts = async (productIds) => {
  try {
    const promises = productIds.map(id => 
      apiClient.delete(`/products/${id}`) // 각 상품 ID에 대해 삭제 요청
    );
    const responses = await Promise.all(promises);
    return responses.map(response => response.data);
  } catch (error) {
    // console.error("❌ 상품 삭제 오류:", error);
    throw error;
  }
};

// 화면 표시용 기본 이미지. 서버로 보내는 값이 아니다 —
// 이 경로를 저장하면 DB에 프론트 파일 경로가 박혀 도메인이 바뀔 때 그 상품만 깨진다.
export const getDefaultImageUrl = () => {
  return "/images/DEFAULT.png"; // 로컬 기본 이미지
};

// 이미지 업로드 API
export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post("/products/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data.imageUrl;
  } catch (error) {
    console.error("이미지 업로드 실패:", error);
    return null;
  }
};

// 상품 이미지 삭제
export const deleteProductImage = async (productId) => {
  try {
    const response = await apiClient.delete(`/products/${productId}/deleteImage`);
    return response.data.success;
  } catch (error) {
    console.error("❌ 이미지 삭제 실패:", error);
    return false;
  }
};

// 상품 이미지 업데이트
export const updateProductImage = async (productId, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file); // ✅ 파일 추가
    formData.append("productId", productId); // ✅ 상품 ID 추가 (백엔드에서 필요할 경우)

    const response = await apiClient.put(`/products/${productId}/updateImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // ✅ 헤더 설정 (중요)
      },
    });

    return response.data.imageUrl;
  } catch (error) {
    console.error("❌ 이미지 업데이트 실패:", error);
    return null;
  }
};

// 상품 재고 변경 
export const updateProductStock = async (productId, quantityChange) => {
  console.log(`📌 [updateProductStock 호출됨] 상품 ID: ${productId}, 변경 수량: ${quantityChange}`);
  try {
    await apiClient.query(
      `UPDATE shops.products
       SET stock = stock - $1
       WHERE id = $2`,
      [quantityChange, productId]
    );
    console.log(`✅ 상품 ID: ${productId}, 재고 ${quantityChange} 차감 성공`);
  } catch (error) {
    console.error(`❌ 재고 차감 실패:`, error);
  }
};


